export class Administration {
  uuid: string;
  name: string;
  street: string;
  housenumber: string;
  zip: string;
  city: string;
  isoCountryId: number;

  email: string;
  url: string;
  telephone: string;
  fax: string;
  gsm: string;

  bic: string;
  iban: string;
  cocNumber: string;

  vatObligated: boolean;
  active: boolean;
}
